export default "__VITE_ASSET__CINGUSqN__"